import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'buildTemporaryStorageKey',

})
export class BuildTemporaryStorageKeyPipe implements PipeTransform {
  transform(args: { businessId: string; id: string; index?: number }): string {
    return buildTemporaryStorageKey(args);
  }
}

export function buildTemporaryStorageKey(args: { businessId: string; id: string; index?: number }): string {
  if (!args) {
    return '';
  }
  const parts = [args.businessId, args.id];
  const indexAsString = args.index?.toString();
  if (indexAsString) {
    parts.push(indexAsString);
  }
  return parts.join('-');
}
